<div id="onboarding-header-component" [ngClass]="isStepperTitle ? 'text-center' : 'text-left'">
  <div class="header-title-step" [ngClass]="isStepperTitle ? 'text-4xl mb-2' : 'text-lg mb-1'">{{ title }}</div>
  <h4 *ngIf="subtitle != ''">{{ subtitle }}</h4>
  <div class="content">{{ content }}</div>
</div>
